// src/Form.js
import './asset/App.css';
import Header from './component/Header';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { Link } from 'react-router-dom';

function FormPage() {
    //const navigate = useNavigate();
    const id = new URLSearchParams(window.location.search).get("id");
    const [formData, setFormData] = useState(false); 

    const [visa, setVisa] = useState(null); 
    const [passport, setPassport] = useState(null); 

    useEffect(() => {
        // 检查 URL 中是否包含 id 参数
        if (id) {
          // 如果有 id 参数，发送 GET 请求到 API
          axios.get(`https://macct.tw/api/form/check?id=${id}`)
            .then((response) => {
              if (response.data.success) {
                // 如果成功，打印数据到控制台
                console.log(response.data);
                setFormData(response.data.form);
                if(response.data.visa){
                    setVisa(response.data.visa);
                }
                if(response.data.passport){
                    setPassport(response.data.passport);
                }
              } else {
                // 如果不成功，重定向到 /home
                console.log(response.data);
                alert("無效的網址");
              }
            })
            .catch((error) => {
              console.error('Error:', error);
              // 发生错误时也可以重定向到 /home
              //navigate('/');
            });
        } else {
            // 如果 id 不存在，重定向到 /home
            alert("無效的網址");
          }
    }, []);

    // 如果没有 id 参数，此时进行重定向
    if (!id) {
        alert("無效的網址");
    }

    
    const handlePaperPrint = () => {
        alert("功能製作中, 待完整版推出");
      };

    // 渲染页面内容
    return (
      <div className="App">
        <Header />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '95%', margin: 'auto' }}>
            <Typography variant="h4" sx={{ textAlign: 'left', mt: 3, mb: 3 }}>
                詳細資料
            </Typography>
            <Button variant="contained" href="#" onClick={handlePaperPrint}>
                紙本下載
            </Button>
        </div>
        <Box>
            { formData ? (
                <Container maxWidth="md" sx={{ mt: 3 }}>    
                    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>姓名：</Typography>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>{formData.fullName}</Typography>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>email：</Typography>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>{formData.email}</Typography>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>國籍：</Typography>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>{formData.nationality}</Typography>
                    </div>
                    
                    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(150px, 200px) 1fr', gap: '16px' }}>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>身分證字號/護照：</Typography>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>{formData.idNumber}</Typography>
                    </div>
                    {passport && (
                        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>護照：</Typography>
                            <Button sx={{ mt: 3,mb: 3 }} variant="contained" color="primary"  href={passport} target="_blank">查看護照</Button>
                        </div>
                    )}
                    {visa && (
                        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                            <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>居留證：</Typography>
                            <Button sx={{ mt: 3,mb: 3 }} variant="contained" color="primary" href={visa} target="_blank" >查看居留證</Button>
                        </div>
                    )}
                    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>居住地址：</Typography>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>{formData.address}</Typography>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>聯絡電話：</Typography>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>{formData.phone}</Typography>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>已加入工會：</Typography>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>{formData.insurance}</Typography>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>申報類別：</Typography>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>{formData.category}</Typography>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>執行業務類別：</Typography>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>{formData.practiceCategory}</Typography>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>金額：</Typography>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>{formData.price}</Typography>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>所得稅額：</Typography>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>{formData.incomePrice}</Typography>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>二代健保：</Typography>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>{formData.insurancePrice}</Typography>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>勞務內容：</Typography>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>{formData.service}</Typography>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>支付日期：</Typography>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>{formData.payDate}</Typography>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>截止日期：</Typography>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>{formData.dueDate}</Typography>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>所得人銀行：</Typography>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>{formData.bank}</Typography>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>銀行分行：</Typography>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>{formData.bankBranch}</Typography>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>銀行帳號：</Typography>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>{formData.bankAccount}</Typography>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 200px) 1fr', gap: '16px' }}>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>帳號名稱：</Typography>
                        <Typography sx={{ minWidth: 120, paddingRight: 2,fontSize: '1.5rem', mt: 2 }}>{formData.accountName}</Typography>
                    </div>
                </Container>
            ) : (
                <Typography>讀取中...</Typography>
            )}
        </Box>
      </div>
    );
  }
  
  export default FormPage;